{
  "welcome": "Bienvenue sur AirPlx {{email}} !",
  "errorTitle": "Nous n'avons pas pu vous connecter.",
  "errorMessage": "Cliquez sur le bouton ci-dessous pour réessayer. Si le problème persiste, veuillez contacter support@airplx.com."
}
